<template>
  <div class="excute-panel">
    <el-dialog
      width="400px"
      :show-close="false"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      custom-class="excute-panel-dialog"
    >
      <div class="panel-header">
        <span
          class="header-icon-btn"
          :tcolor="type"
          :class="iconClassMap.get(type)"
        ></span>
        <span class="header-title">{{ title }}</span>
      </div>
      <div class="panel-main">
        <span class="tips">{{ computedTips }}</span>
      </div>
      <div class="panel-footer">
        <el-button :size="$elsize" @click="close('cancel')">{{
          cancelBtnText
        }}</el-button>
        <el-button :size="$elsize" type="primary" @click="close('confirm')">{{
          confirmBtnText
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "excute-panel",
  props: {
    // duration: {
    //   type: Number,
    //   default: 0,
    // },
    type: {
      type: String,
      default: "info",
    },
    title: {
      type: String,
      default: "操作成功",
    },
    tips: {
      type: String,
      default: "",
    },
    showCancelBtn: {
      type: Boolean,
      default: false,
    },
    cancelBtnText: {
      type: String,
      default: "取 消",
    },
  },
  data() {
    return {
      visible: false,
      duration: 0,
      downTimeCount: 0,
      downTimer: null,
      iconClassMap: new Map([
        ["success", "el-icon-success"],
        ["danger", "el-icon-error"],
        ["info", "el-icon-info"],
        ["warning", "el-icon-warning"],
        ["primary", "el-icon-remove"],
        ["normal", "el-icon-info"],
      ]),
    };
  },
  watch: {
    visible: {
      handler(visible) {
        visible && this.duration && this.startTimer();
      },
      immediate: true,
    },
  },
  computed: {
    confirmBtnText() {
      if (!this.duration) return "确定";
      const t = this.downTimeCount / 1000;
      return t + "秒后返回";
    },
    computedTips() {
      const { tips, duration, title } = this;
      if (tips) return this.tips;
      if (!duration) return `${title || "操作成功"} ，是否返回上一页面`;
      const ts = duration / 1000;
      return `${title || "操作成功"}，${ts}s 后自动返回`;
    },
  },

  methods: {
    clearTimer() {
      this.duration = 0;
      this.downTimeCount = 0;
      this.downTimer && clearInterval(this.downTimer);
      this.downTimer = null;
    },
    startTimer() {
      this.downTimeCount = this.duration;
      this.downTimer = setInterval(() => {
        if (this.downTimeCount <= 0) return this.close("confirm");
        this.downTimeCount -= 1000;
      }, 1000);
    },
    close(action = "confirm") {
      this.visible = false;
      this.clearTimer();
      this.$el.parentNode.removeChild(this.$el);
      this.$emit("close", action);
      this.$off('close')
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .excute-panel-dialog {
  border-radius: 4px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 16px 12px;
  }
  .el-dialog__footer {
    padding: 16px 12px;
  }
  .panel-header {
    display: flex;
    align-items: center;
    gap: 8px;
    .header-title {
      font-size: 16px;
    }
    .header-icon-btn {
      font-size: 26px;
      &[tcolor="success"] {
        color: var(--color-success);
      }
      &[tcolor="danger"] {
        color: var(--color-danger);
      }
      &[tcolor="warning"] {
        color: var(--color-warning);
      }
      &[tcolor="normal"] {
        color: var(--color-normal);
      }
      &[tcolor="primary"] {
        color: var(--color-primary);
      }
      &[tcolor="info"] {
        color: var(--color-info);
      }
    }
  }
  .panel-main {
    padding: 12px 32px;
    font-size: 14px;
    line-height: 1.5em;
    color: var(--color-info-light);
  }
  .panel-footer {
    margin-top: 8px;
    gap: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
